module.exports = __webpack_public_path__ + "static/media/no_image.346e44a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/no_image.svg
// module id = 338
// module chunks = 0